export const generateBackground = (width, height) => {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');

  // Draw base dark background
  ctx.fillStyle = '#121212';
  ctx.fillRect(0, 0, width, height);

  return canvas.toDataURL();
};